import AffinityIFrame from "./affinity";
import Iframe from "./iframe";
import Modal from "./modal";
import { type IframeUserConfiguration } from "../types/types";

import "../../scss/sheerid-iframe.scss";

// Called from the parent page to load the jslib within an iFrame NOT in a modal, but in the flow of a page. e.g. between two divs
export function loadInlineIframe(containerElement: HTMLElement, url: string): Iframe {
  const iframe = new Iframe(containerElement, url);
  iframe.init();
  return iframe;
}

// Called from the parent page to load the jslib within an iFrame in a modal
export function loadInModal(url: string, userConfig: IframeUserConfiguration = {}) {
  const modal = new Modal(url, userConfig);
  modal.init();
  return modal;
}

export function loadAffinityIFrame(containerElement: HTMLElement, url: string): AffinityIFrame {
  const affinity = new AffinityIFrame(containerElement, url);
  affinity.init();
  return affinity;
}

// Explicitly excluding loadAffinityIFrame from the default export until it becomes GA
export default { loadInModal, loadInlineIframe };
